/* Action types with TypeScript type declaration */
export const TOGGLE_MSRP = 'rpb2b-react/msrp/ToggleMSRP';
export type TOGGLE_MSRP = typeof TOGGLE_MSRP;

export default {
  TOGGLE_MSRP
};
